import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { useState } from "react";

type ReportPromptDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onReport: (reason: string) => void;
  isReporting?: boolean;
};

export function ReportPromptDialog({ open, onOpenChange, onReport, isReporting = false }: ReportPromptDialogProps) {
  const [reason, setReason] = useState("");

  const handleReport = () => {
    if (reason.trim()) {
      onReport(reason.trim());
      setReason("");
    }
  };

  const handleClose = () => {
    setReason("");
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={handleClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Report Prompt</DialogTitle>
          <DialogDescription>
            Please provide a reason for reporting this prompt. Our moderation team will review it.
          </DialogDescription>
        </DialogHeader>
        
        <div className="space-y-4">
          <Textarea
            placeholder="Describe why you're reporting this prompt..."
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            className="min-h-[100px]"
          />
        </div>
        
        <DialogFooter className="flex justify-end space-x-2 pt-4">
          <Button 
            variant="outline" 
            onClick={handleClose}
            disabled={isReporting}
          >
            Cancel
          </Button>
          <Button 
            variant="destructive"
            onClick={handleReport}
            disabled={!reason.trim() || isReporting}
          >
            {isReporting ? "Reporting..." : "Report"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}